import './utils/newRelic';
import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { cssCustomProperties } from '@fikasio/styles';
import store from 'services/store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { envvars } from './utils/envvars';
import { initializeTranslation } from './utils/translation';
import './index.css';

if (!document.head.querySelector('style[data-fikasio-styles]')) {
  const themeStyle = document.createElement('style');
  themeStyle.dataset.fikasioStyles = 'true';
  themeStyle.textContent = cssCustomProperties;
  document.head.appendChild(themeStyle);
}

ReactGA.initialize(envvars.googleAnalyticsId, {
  gtagOptions: { send_page_view: false },
});
initializeTranslation();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
